var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "25",
        height: "25",
        viewBox: "0 0 25 25",
      },
    },
    [
      _c("g", { attrs: { fill: "none", "fill-rule": "evenodd" } }, [
        _c("path", { attrs: { d: "M25 0H0v25h25z" } }),
        _vm._v(" "),
        _c(
          "g",
          { attrs: { fill: _vm.color, transform: "matrix(-1 0 0 1 25 4)" } },
          [
            _c("rect", {
              attrs: {
                width: "10",
                height: "2",
                y: "4",
                rx: ".3",
                transform: "rotate(-45 5 5)",
              },
            }),
            _vm._v(" "),
            _c("rect", {
              attrs: { width: "20", height: "2", x: "2", y: "7.5", rx: ".3" },
            }),
            _vm._v(" "),
            _c("rect", {
              attrs: {
                width: "11",
                height: "2",
                x: "-.904",
                y: "10.596",
                rx: ".3",
                transform: "rotate(45 4.596 11.596)",
              },
            }),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }